module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./~/_axios@0.18.0@axios/index.js
// module id = 202
// module chunks = 0